import {
  FETCH_NOTIFICATION_RECIPIENTS_ATTEMPT,
  FETCH_NOTIFICATION_RECIPIENTS_SUCCESS,
  FETCH_NOTIFICATION_RECIPIENTS_ERROR,
  CREATE_NOTIFICATION_RECIPIENT_ATTEMPT,
  CREATE_NOTIFICATION_RECIPIENT_SUCCESS,
  CREATE_NOTIFICATION_RECIPIENT_ERROR,
  CREATE_NOTIFICATION_RECIPIENT_RESET_STATE,
  DELETE_NOTIFICATION_RECIPIENT_ATTEMPT,
  DELETE_NOTIFICATION_RECIPIENT_SUCCESS,
  DELETE_NOTIFICATION_RECIPIENT_ERROR,
  DELETE_NOTIFICATION_RECIPIENT_RESET_STATE,
  TOGGLE_NOTIFICATION_RECIPIENT_ATTEMPT,
  TOGGLE_NOTIFICATION_RECIPIENT_SUCCESS,
  TOGGLE_NOTIFICATION_RECIPIENT_ERROR,
  UPDATE_NOTIFICATION_RECIPIENT_ATTEMPT,
  UPDATE_NOTIFICATION_RECIPIENT_SUCCESS,
  UPDATE_NOTIFICATION_RECIPIENT_ERROR,
  UPDATE_NOTIFICATION_RECIPIENT_RESET_STATE,
  FETCH_NOTIFICATION_SUBSCRIPTIONS_ATTEMPT,
  FETCH_NOTIFICATION_SUBSCRIPTIONS_SUCCESS,
  FETCH_NOTIFICATION_SUBSCRIPTIONS_ERROR,
  CREATE_NOTIFICATION_SUBSCRIPTION_ATTEMPT,
  CREATE_NOTIFICATION_SUBSCRIPTION_SUCCESS,
  CREATE_NOTIFICATION_SUBSCRIPTION_ERROR,
  CREATE_NOTIFICATION_SUBSCRIPTION_RESET_STATE,
  DELETE_NOTIFICATION_SUBSCRIPTION_ATTEMPT,
  DELETE_NOTIFICATION_SUBSCRIPTION_SUCCESS,
  DELETE_NOTIFICATION_SUBSCRIPTION_ERROR,
  DELETE_NOTIFICATION_SUBSCRIPTION_RESET_STATE,
  TOGGLE_NOTIFICATION_SUBSCRIPTION_ATTEMPT,
  TOGGLE_NOTIFICATION_SUBSCRIPTION_SUCCESS,
  TOGGLE_NOTIFICATION_SUBSCRIPTION_ERROR,
  UPDATE_NOTIFICATION_SUBSCRIPTION_ATTEMPT,
  UPDATE_NOTIFICATION_SUBSCRIPTION_SUCCESS,
  UPDATE_NOTIFICATION_SUBSCRIPTION_ERROR,
  UPDATE_NOTIFICATION_SUBSCRIPTION_RESET_STATE,
  FETCH_BUSINESS_UNITS_ATTEMPT,
  FETCH_BUSINESS_UNITS_SUCCESS,
  FETCH_BUSINESS_UNITS_ERROR,
} from "../../actions/admin/notifications";

const INIT_STATE = {
  recipients: {
    attempt: false,
    success: false,
    error: null,
    data: [],
  },
  createRecipient: {
    attempt: false,
    success: false,
    error: null,
  },
  deleteRecipient: {
    attempt: false,
    success: false,
    error: null,
  },
  toggleRecipient: {
    attempt: false,
    success: false,
    error: null,
  },
  updateRecipient: {
    attempt: false,
    success: false,
    error: null,
  },
  // Subscriptions (per-user, per-business-unit)
  subscriptions: {
    attempt: false,
    success: false,
    error: null,
    data: [],
  },
  createSubscription: {
    attempt: false,
    success: false,
    error: null,
  },
  deleteSubscription: {
    attempt: false,
    success: false,
    error: null,
  },
  toggleSubscription: {
    attempt: false,
    success: false,
    error: null,
  },
  updateSubscription: {
    attempt: false,
    success: false,
    error: null,
  },
  businessUnits: {
    attempt: false,
    success: false,
    error: null,
    data: [],
  },
};

const notificationsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Recipients
    case FETCH_NOTIFICATION_RECIPIENTS_ATTEMPT:
      return {
        ...state,
        recipients: {
          ...state.recipients,
          attempt: true,
          error: null,
        },
      };
    case FETCH_NOTIFICATION_RECIPIENTS_SUCCESS:
      return {
        ...state,
        recipients: {
          attempt: false,
          success: true,
          error: null,
          data: action.payload.data,
        },
      };
    case FETCH_NOTIFICATION_RECIPIENTS_ERROR:
      return {
        ...state,
        recipients: {
          ...state.recipients,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };

    case CREATE_NOTIFICATION_RECIPIENT_ATTEMPT:
      return {
        ...state,
        createRecipient: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case CREATE_NOTIFICATION_RECIPIENT_SUCCESS:
      return {
        ...state,
        createRecipient: {
          attempt: false,
          success: true,
          error: null,
        },
      };
    case CREATE_NOTIFICATION_RECIPIENT_ERROR:
      return {
        ...state,
        createRecipient: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case CREATE_NOTIFICATION_RECIPIENT_RESET_STATE:
      return {
        ...state,
        createRecipient: {
          attempt: false,
          success: false,
          error: null,
        },
      };

    case DELETE_NOTIFICATION_RECIPIENT_ATTEMPT:
      return {
        ...state,
        deleteRecipient: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case DELETE_NOTIFICATION_RECIPIENT_SUCCESS:
      return {
        ...state,
        deleteRecipient: {
          attempt: false,
          success: true,
          error: null,
        },
        recipients: {
          ...state.recipients,
          data: state.recipients.data.filter(
            (rec) => rec.id !== action.payload.id
          ),
        },
      };
    case DELETE_NOTIFICATION_RECIPIENT_ERROR:
      return {
        ...state,
        deleteRecipient: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case DELETE_NOTIFICATION_RECIPIENT_RESET_STATE:
      return {
        ...state,
        deleteRecipient: {
          attempt: false,
          success: false,
          error: null,
        },
      };

    case TOGGLE_NOTIFICATION_RECIPIENT_ATTEMPT:
      return {
        ...state,
        toggleRecipient: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case TOGGLE_NOTIFICATION_RECIPIENT_SUCCESS:
      return {
        ...state,
        toggleRecipient: {
          attempt: false,
          success: true,
          error: null,
        },
        recipients: {
          ...state.recipients,
          data: state.recipients.data.map((rec) =>
            rec.id === action.payload.id
              ? { ...rec, enabled: !rec.enabled }
              : rec
          ),
        },
      };
    case TOGGLE_NOTIFICATION_RECIPIENT_ERROR:
      return {
        ...state,
        toggleRecipient: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };

    case UPDATE_NOTIFICATION_RECIPIENT_ATTEMPT:
      return {
        ...state,
        updateRecipient: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case UPDATE_NOTIFICATION_RECIPIENT_SUCCESS:
      return {
        ...state,
        updateRecipient: {
          attempt: false,
          success: true,
          error: null,
        },
      };
    case UPDATE_NOTIFICATION_RECIPIENT_ERROR:
      return {
        ...state,
        updateRecipient: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case UPDATE_NOTIFICATION_RECIPIENT_RESET_STATE:
      return {
        ...state,
        updateRecipient: {
          attempt: false,
          success: false,
          error: null,
        },
      };

    // Subscriptions
    case FETCH_NOTIFICATION_SUBSCRIPTIONS_ATTEMPT:
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          attempt: true,
          error: null,
        },
      };
    case FETCH_NOTIFICATION_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        subscriptions: {
          attempt: false,
          success: true,
          error: null,
          data: action.payload.data,
        },
      };
    case FETCH_NOTIFICATION_SUBSCRIPTIONS_ERROR:
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };

    case CREATE_NOTIFICATION_SUBSCRIPTION_ATTEMPT:
      return {
        ...state,
        createSubscription: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case CREATE_NOTIFICATION_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        createSubscription: {
          attempt: false,
          success: true,
          error: null,
        },
      };
    case CREATE_NOTIFICATION_SUBSCRIPTION_ERROR:
      return {
        ...state,
        createSubscription: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case CREATE_NOTIFICATION_SUBSCRIPTION_RESET_STATE:
      return {
        ...state,
        createSubscription: {
          attempt: false,
          success: false,
          error: null,
        },
      };

    case DELETE_NOTIFICATION_SUBSCRIPTION_ATTEMPT:
      return {
        ...state,
        deleteSubscription: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case DELETE_NOTIFICATION_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        deleteSubscription: {
          attempt: false,
          success: true,
          error: null,
        },
        subscriptions: {
          ...state.subscriptions,
          data: state.subscriptions.data.filter(
            (sub) => sub.id !== action.payload.id
          ),
        },
      };
    case DELETE_NOTIFICATION_SUBSCRIPTION_ERROR:
      return {
        ...state,
        deleteSubscription: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case DELETE_NOTIFICATION_SUBSCRIPTION_RESET_STATE:
      return {
        ...state,
        deleteSubscription: {
          attempt: false,
          success: false,
          error: null,
        },
      };

    case TOGGLE_NOTIFICATION_SUBSCRIPTION_ATTEMPT:
      return {
        ...state,
        toggleSubscription: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case TOGGLE_NOTIFICATION_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        toggleSubscription: {
          attempt: false,
          success: true,
          error: null,
        },
        subscriptions: {
          ...state.subscriptions,
          data: state.subscriptions.data.map((sub) =>
            sub.id === action.payload.id
              ? { ...sub, subscribed: !sub.subscribed }
              : sub
          ),
        },
      };
    case TOGGLE_NOTIFICATION_SUBSCRIPTION_ERROR:
      return {
        ...state,
        toggleSubscription: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };

    case UPDATE_NOTIFICATION_SUBSCRIPTION_ATTEMPT:
      return {
        ...state,
        updateSubscription: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case UPDATE_NOTIFICATION_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        updateSubscription: {
          attempt: false,
          success: true,
          error: null,
        },
      };
    case UPDATE_NOTIFICATION_SUBSCRIPTION_ERROR:
      return {
        ...state,
        updateSubscription: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case UPDATE_NOTIFICATION_SUBSCRIPTION_RESET_STATE:
      return {
        ...state,
        updateSubscription: {
          attempt: false,
          success: false,
          error: null,
        },
      };

    // Business Units
    case FETCH_BUSINESS_UNITS_ATTEMPT:
      return {
        ...state,
        businessUnits: {
          ...state.businessUnits,
          attempt: true,
          error: null,
        },
      };
    case FETCH_BUSINESS_UNITS_SUCCESS:
      return {
        ...state,
        businessUnits: {
          attempt: false,
          success: true,
          error: null,
          data: action.payload.data,
        },
      };
    case FETCH_BUSINESS_UNITS_ERROR:
      return {
        ...state,
        businessUnits: {
          ...state.businessUnits,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default notificationsReducer;
